const admin = [
  {
    title: 'Dashboard',
    icon: 'mdi-view-dashboard',
    to: '/app/dashboard',
  },
  {
    title: 'Map Pincode',
    icon: 'mdi-map-marker-distance',
    to: '/app/map-pincode',
  },
  {
    title: 'Mapped Pincode',
    icon: 'mdi-map-marker-distance',
    to: '/app/mapped-pincode',
  },
  {
    title: 'Order UID',
    icon: 'mdi-cash-register',
    to: '/app/orderuid',
  },
  {
    title: 'Orders',
    icon: 'mdi-basket',
    children: [
      {
        title: 'View Orders',
        icon: 'mdi-basket',
        to: '/app/orders/view',
      },
      {
        title: 'Map Order\'s Pincode',
        icon: 'mdi-map-marker-distance',
        to: '/app/orders/map-pincode',
      },
    ],
  },
  /* {
    title: 'Channel Partners Types',
    icon: 'mdi-account-cog',
    to: '/app/channel-partners-types',
  }, */
  {
    title: 'Trade Policy Users',
    icon: 'mdi-account-cog',
    children: [
      {
        title: 'Import / Export',
        icon: 'mdi-account-cog',
        to: '/app/trade-policy-users/import-export',
      },
      {
        title: 'Add User',
        icon: 'mdi-account-cog',
        to: '/app/trade-policy-users/add-user',
      },
      {
        title: 'Edit User',
        icon: 'mdi-account-cog',
        to: '/app/trade-policy-users/edit-user',
      },
    ],
  },
  {
    title: 'Trade Policy Enrollments',
    icon: 'mdi-account-cog',
    to: '/app/trade-policy-agreements',
  },
  {
    title: 'ASOs Management',
    icon: 'mdi-account-cog',
    children: [
      {
        title: 'Manage ASOs',
        icon: 'mdi-account-details',
        to: '/app/asos/manage',
      },
      {
        title: 'Create Aso',
        icon: 'mdi-account-plus',
        to: '/app/asos/create',
      },
    ],
  },
];

const nonAdmin = [
  {
    title: 'Dashboard',
    icon: 'mdi-view-dashboard',
    to: '/app/dashboard',
  },
  {
    title: 'Map Pincode',
    icon: 'mdi-map-marker-distance',
    to: '/app/map-pincode',
  },
  {
    title: 'Mapped Pincode',
    icon: 'mdi-map-marker-distance',
    to: '/app/mapped-pincode',
  },
  {
    title: 'Orders',
    icon: 'mdi-basket',
    children: [
      {
        title: 'View Orders',
        icon: 'mdi-basket',
        to: '/app/orders/view',
      },
      {
        title: 'Map Order\'s Pincode',
        icon: 'mdi-map-marker-distance',
        to: '/app/orders/map-pincode',
      },
    ],
  },
  /* {
    title: 'Channel Partners Types',
    icon: 'mdi-account-cog',
    to: '/app/channel-partners-types',
  }, */
];

export default (email) => {
  let menu = nonAdmin;
  if (email === 'admin@kurlon.com') {
    menu = admin;
  }
  return menu;
};
